import PenIcon from "./PenIcon.mjs";

export default class ImWriteNewIcon extends PenIcon {};

